const INDEX_ITEMS = [
  { letter: '纯', label: '纯爱系列', count: '428 部', desc: '甜蜜恋爱、青春校园、都市情感等温馨故事' },
  { letter: '奇', label: '奇幻冒险', count: '316 部', desc: '异世界穿越、魔法冒险、史诗幻想题材' },
  { letter: '热', label: '热血战斗', count: '289 部', desc: '动作对决、格斗竞技、少年成长之路' },
  { letter: '悬', label: '悬疑推理', count: '195 部', desc: '烧脑谜题、心理博弈、犯罪追踪故事' },
  { letter: '笑', label: '搞笑日常', count: '352 部', desc: '日常喜剧、搞笑段子、轻松疗愈作品' },
  { letter: '古', label: '国风古韵', count: '241 部', desc: '古风仙侠、历史传奇、东方美学画卷' },
  { letter: '玄', label: '玄幻架空', count: '273 部', desc: '东方玄幻、修炼体系、大世界观构建' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <h2 className="text-[22px] md:text-[28px] font-heading font-bold text-foreground-950 text-center mb-3">
          主题索引
        </h2>
        <p className="text-[14px] text-foreground-500 text-center mb-10">
          按类型字母索引，快速定位你感兴趣的漫画世界
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {INDEX_ITEMS.map((item) => (
            <div
              key={item.label}
              className="group flex items-start gap-3 bg-background-100 rounded-xl p-4 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/20 transition-all cursor-pointer"
            >
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-200 transition-colors">
                <span className="text-[16px] font-extrabold text-primary-600">{item.letter}</span>
              </div>
              <div className="min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="text-[14px] font-bold text-foreground-800">{item.label}</h3>
                  <span className="text-[11px] text-accent-500 font-semibold whitespace-nowrap">{item.count}</span>
                </div>
                <p className="text-[12px] text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
          <div className="flex items-center justify-center bg-background-100 rounded-xl p-4 border border-dashed border-background-300 hover:border-primary-300 transition-all cursor-pointer">
            <span className="text-[14px] text-foreground-400 font-medium">
              更多分类 <i className="ri-arrow-right-line ml-1"></i>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}